import React from 'react'

// material-ui
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

// local components
import NavStepper from './NavStepper'

const DesktopNav = props => {
  return (
    <Box displayPrint='none'>
      <Container maxWidth='md'>
        <NavStepper orientation='horizontal' alternativeLabel {...props} />
      </Container>
    </Box>
  )
}

export default DesktopNav
